import { RatingWorkplaceParams } from '../../types/Rating/RatingTypes';

const PLACEHOLDER = '-';

function parseWorkplaceNumber(raw: string | null): number | null {
  if (!raw) {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed || trimmed === PLACEHOLDER) {
    return null;
  }
  const num = Number(trimmed);
  return Number.isFinite(num) ? num : null;
}

export function formatWorkplaceNumber(value: number | null | undefined): string {
  return value !== null && value !== undefined ? String(value) : PLACEHOLDER;
}

export function parseRatingParams(search: string): RatingWorkplaceParams | null {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const branch = Number(params.get('branch'));
  const queue = params.get('queue')?.trim() ?? '';
  const cabinet = parseWorkplaceNumber(params.get('cabinet'));
  const window = parseWorkplaceNumber(params.get('window'));

  if (!Number.isFinite(branch) || !queue) {
    return null;
  }

  return { branch, queue, cabinet, window };
}